<template>
  <footer class="footer">
    <div class="footer-container">
      <!-- Main Footer Content -->
      <div class="footer-content">
        <!-- Company Info -->
        <div class="footer-section">
          <h5 class="footer-title">Компанія</h5>

          <div class="footer-contacts">
            <a href="tel:+380950070403" class="contact-link">
              <i class="fa fa-phone"></i>
              <span>+38 (095) 007 04 03</span>
            </a>
            <a href="tel:+380730070403" class="contact-link">
              <i class="fa fa-phone"></i>
              <span>+38 (073) 007 04 03</span>
            </a>
            <a href="tel:+380970070403" class="contact-link">
              <i class="fa fa-phone"></i>
              <span>+38 (097) 007 04 03</span>
            </a>
            <a href="mailto:dsp.service@mm.ck.ua" class="contact-link">
              <i class="far fa-envelope"></i>
              <span>dsp.service@mm.ck.ua</span>
            </a>
          </div>
        </div>

        <!-- Navigation -->
        <div class="footer-section">
          <h5 class="footer-title">Допомога</h5>
          <ul class="footer-nav">
            <li>
              <router-link :to="{ name: 'Help', hash: '#videos' }" class="footer-link">
                <i class="fa fa-play-circle"></i>
                Відео
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Help', hash: '#templates' }" class="footer-link">
                <i class="fa fa-th-large"></i>
                Шаблони
              </router-link>
            </li>

          </ul>
        </div>

        <!-- Services -->
        <div class="footer-section">
          <h5 class="footer-title">Послуги</h5>
          <ul class="footer-nav">
            <li>
              <router-link :to="{ name: 'Main' }" class="footer-link">
                <i class="fa fa-cube"></i>
                Конструктор
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'order' }" class="footer-link">
                <i class="fa fa-shopping-cart"></i>
                Замовлення
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'Products' }" class="footer-link">
                <i class="fa fa-box"></i>
                Вироби
              </router-link>
            </li>

          </ul>
        </div>
      </div>

      <!-- Footer Bottom -->
      <div class="footer-bottom">
        <div class="footer-bottom-content">
          <p class="copyright">
            © {{ new Date().getFullYear() }} Всі права захищені
          </p>
          <div class="footer-social">
            <a href="https://www.facebook.com/Meblevuymaister" target="_blank" class="social-link" title="Facebook">
              <i class="fab fa-facebook"></i>
            </a>
            <a href="https://www.instagram.com/mm.ck.ua/" target="_blank" class="social-link" title="Instagram">
              <i class="fab fa-instagram"></i>
            </a>

          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      url: appconfig.Point
    }
  }
}
</script>

<style scoped>
.footer {
  background-color: #2c3e50;
  color: #ecf0f1;
  padding: 3rem 0 1rem;
  margin-top: auto;
}

.footer-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 1rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}

.footer-section {
  display: flex;
  flex-direction: column;
}

.footer-title {
  color: #ff182d;
  font-size: 1.1rem;
  font-weight: 600;
  margin-bottom: 1rem;
  border-bottom: 2px solid #ff182d;
  padding-bottom: 0.5rem;
}

.footer-description {
  color: #bdc3c7;
  font-size: 0.9rem;
  line-height: 1.5;
  margin-bottom: 1rem;
}

.footer-contacts {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.contact-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #ecf0f1;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.2s ease;
}

.contact-link:hover {
  color: #ff182d;
  text-decoration: none;
}

.contact-link i {
  color: #ff182d;
  width: 16px;
}

.footer-nav {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: #bdc3c7;
  text-decoration: none;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  padding: 0.25rem 0;
}

.footer-link:hover {
  color: #ff182d;
  text-decoration: none;
  transform: translateX(5px);
}

.footer-link i {
  color: #ff182d;
  width: 16px;
}

.footer-bottom {
  border-top: 1px solid #34495e;
  padding-top: 1rem;
}

.footer-bottom-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.copyright {
  color: #95a5a6;
  font-size: 0.85rem;
  margin: 0;
}

.footer-social {
  display: flex;
  gap: 1rem;
}

.social-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background-color: #34495e;
  color: #ecf0f1;
  border-radius: 50%;
  text-decoration: none;
  transition: all 0.2s ease;
}

.social-link:hover {
  background-color: #ff182d;
  color: white;
  transform: translateY(-2px);
  text-decoration: none;
}

/* Responsive */
@media (max-width: 768px) {
  .footer {
    padding: 2rem 0 1rem;
  }

  .footer-content {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .footer-bottom-content {
    flex-direction: column;
    text-align: center;
  }

  .footer-social {
    justify-content: center;
  }
}
</style>